"use client";

import { isEmptyContentfulEntry } from "@helpers";
import type { IModuleFaqFields } from "@types-contentful";
import React from "react";
import styled from "styled-components";
import AccordionModuleItems from "./AccordionModule/AccordionModuleItems";
import { usePathname } from "next/navigation";
import { buildFaqPageJsonLd } from "@helpers/faqSchema";

const Container = styled.div`
  padding: 40px 35px 40px 35px;
  @media (min-width: 834px) {
    padding: 40px 10% 75px 10%;
  }
  overflow: hidden;
`;

const H2 = styled.h2`
  margin-bottom: 24px;
  @media (min-width: 834px) {
    margin-bottom: 32px;
  }
`;

const FaqItemsContainer = styled.div``;

const FAQModule = ({ items, title, itemsHelpsite }: IModuleFaqFields) => {
	const pathname = usePathname();
	const siteOrigin = process.env.NEXT_PUBLIC_SITE_ORIGIN;
	const pageUrl = siteOrigin ? `${siteOrigin}${pathname}` : undefined;

	// items are linked entries -> build schema from their fields
	const faqSchema = buildFaqPageJsonLd(
		(items ?? []).map((i) => i.fields),
		pageUrl,
	);

	return (
		<Container>
			{faqSchema && (
				<script
					type="application/ld+json"
					dangerouslySetInnerHTML={{ __html: JSON.stringify(faqSchema) }}
				/>
			)}

			{!isEmptyContentfulEntry(title) && <H2>{title}</H2>}

			<FaqItemsContainer>
				{(items ?? []).map((item) => (
					<AccordionModuleItems key={item.sys.id} faq={item.fields} />
				))}
				{(itemsHelpsite ?? []).map((item) => (
					<AccordionModuleItems key={item.sys.id} faq={item.fields} />
				))}
			</FaqItemsContainer>
		</Container>
	);
};

export default FAQModule;
